module.exports = __webpack_public_path__ + "img/cassette-vhs.a4c5fb20.svg";